/** Параметры employee API для выбора участников Matrix-чата */
export const MATRIX_EMPLOYEE_QUERY_PARAMS = {
  fields: 'matrix_user_id',
  has_matrix_id: true,
} as const
